import Pagination from './pagination/';
import PropTypes from 'prop-types';
import React from 'react';

const ResultsFooter = ({changeFilter, location, params, resultState}) => {
  return (
    <div className="container">
      <div className="row">
        <div className="right-box col-xs-16">
          <Pagination
            count={resultState.resultCount}
            pageSize={resultState.filter.resultsPerPage}
            activePage={resultState.filter.activePage}
            params={params}
            location={location}
            changeFilter={changeFilter}
          />
        </div>
      </div>
      <div className="spacer-2">&nbsp;</div>
    </div>
  );
}

ResultsFooter.propTypes = {
  changeFilter: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  resultState: PropTypes.object.isRequired
}

export default ResultsFooter;



// WEBPACK FOOTER //
// ./src/components/search/results-footer.js